/**
 * Photos d'installations PRODEVAL de l'écran de connexion (fond du panneau d'actualité, diaporama PhotoSlideshow).
 *
 * Fournies par la DSI le 04/11/2026 : unité d'épuration de biométhane (gros plan, conteneur au logo PRODEVAL) et vue
 * aérienne d'un site (digesteurs, cuves). Variantes produites hors du dépôt depuis les originaux (sans métadonnées) :
 * AVIF qualité 50, WebP qualité 74, JPEG progressif qualité 76 (repli). L'original de la vue aérienne ne fait que
 * 901 px de large : une version plus grande (≥ 1920 px) la rendrait plus nette sur les grands écrans.
 * Importées par Vite : noms versionnés dans assets/, mis en cache un an par CloudFront (scripts/deployer-socle.sh).
 */
import type { SlidePhoto } from '../../../design';
import unite800Avif from './unite-epuration-800.avif';
import unite1280Avif from './unite-epuration-1280.avif';
import unite1920Avif from './unite-epuration-1920.avif';
import unite800Webp from './unite-epuration-800.webp';
import unite1280Webp from './unite-epuration-1280.webp';
import unite1920Webp from './unite-epuration-1920.webp';
import unite1280Jpeg from './unite-epuration-1280.jpg';
import site900Avif from './site-biomethane-900.avif';
import site900Webp from './site-biomethane-900.webp';
import site900Jpeg from './site-biomethane-900.jpg';
import site480Webp from './site-biomethane-480.webp';

export const PHOTOS_CONNEXION: SlidePhoto[] = [
  {
    avif: `${unite800Avif} 800w, ${unite1280Avif} 1280w, ${unite1920Avif} 1920w`,
    webp: `${unite800Webp} 800w, ${unite1280Webp} 1280w, ${unite1920Webp} 1920w`,
    jpeg: unite1280Jpeg,
    // Garder le conteneur au logo PRODEVAL dans le cadre (à gauche de la photo).
    focus: '22% 55%',
  },
  {
    avif: `${site900Avif} 900w`,
    webp: `${site900Webp} 900w`,
    jpeg: site900Jpeg,
    focus: '50% 45%',
  },
];

/**
 * Largeur affichée du panneau d'actualité (attribut sizes) : tout l'écran sur un téléphone ou une tablette (panneau
 * au-dessus de la connexion), l'écran moins la colonne de connexion au-delà (bundle.css › .ag-login-screen).
 */
export const TAILLES_PHOTOS_CONNEXION = '(max-width: 900px) 100vw, calc(100vw - 400px)';

/**
 * Mêmes photos en WebP pour les visuels des actualités d'exemple (donnees-exemple.ts) : vignettes « À lire aussi » de
 * la connexion et widget d'actualité de l'accueil. L'unité sert aussi de grande image à la première actualité du widget
 * (≈ 540 px de large) : 800 px ; la vue aérienne n'y est qu'une vignette : 480 px (≈ 20 Ko).
 */
export const VIGNETTES_PHOTOS = { unite: unite800Webp, site: site480Webp };
